/* eslint-disable react/no-unused-state */
import React from "react";
import * as storage from "./util/storage";
import { loadAndValidateTokens } from "./util/auth";
import AppStateProvider from "./providers/AppStateProvider";
import App from "./App";
import getInitialData from "./api/getInitialData";

export default class AppWithState extends React.Component {
  constructor(props) {
    super(props);

    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
    this.refresh = this.refresh.bind(this);

    this.state = {
      isAuthenticated: false,
      isInitializing: true,
      me: null,
      isLoadingInitialData: true,
      login: this.login,
      logout: this.logout,
      refresh: this.refresh,
    };
  }

  async componentDidMount() {
    const { apolloClient } = this.props;
    try {
      const { isAuthenticated } = await this.loadTokens();
      await apolloClient.resetStore();
      if (isAuthenticated) {
        await this.fetchInitialData();
      }
      
      this.setState({
      isInitializing: false,
      isAuthenticated,
    });
    } catch {
      this.logout();
      this.setState({ isInitializing: false });
    }
  }

  async fetchInitialData() {
    const { apolloClient } = this.props;
    const { me } = await getInitialData(apolloClient);

    this.setState({
      isAuthenticated: true,
      isLoadingInitialData: false,
      me,
    });
  }

  async loadTokens() {
    const { accessToken } = await loadAndValidateTokens();
    const isAuthenticated = accessToken !== null;
    this.setState((prevState) => ({
      ...prevState,
      isAuthenticated,
      isLoadingTokens: false,
    }));
    return { isAuthenticated };
  }

  async login(accessToken, refreshToken, me) {
    await storage.setAccessToken(accessToken);
    await storage.setRefreshToken(refreshToken);
    this.setState((prevState) => ({
      ...prevState,
      isAuthenticated: true,
      me,
      isLoadingInitialData: false,
    }));
  }

  async logout() {
    await Promise.all([
      storage.removeAccessToken(),
      storage.removeRefreshToken(),
    ]);
    this.setState((prevState) => ({
      ...prevState,
      me: null,
      isAuthenticated: false,
      isLoadingTokens: false,
    }));
  }

  async refresh() {
    const { apolloClient } = this.props;
    this.setState((prevState) => ({
      ...prevState,
      me: null,
      isAuthenticated: false,
      isLoadingTokens: false,
    }));
    await this.loadTokens();
    await apolloClient.resetStore();
  }

  render() {
    const { notificationDispatcher, history, apolloClient } = this.props;
    const { isInitializing } = this.state;
    console.log('isInitializing:', isInitializing);
    return ( isInitializing ? null :
      <AppStateProvider value={this.state}>
        <App
          history={history}
          apolloClient={apolloClient}
          notificationDispatcher={notificationDispatcher}
        />
      </AppStateProvider>
    );
  }
}
